// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgDisconnectedArrowsArrows = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.274 9.018a.685.685 0 0 1-.936 0 .61.61 0 0 1 0-.893l2.4-2.29h-1.005V4.572h1.006l-2.401-2.29a.61.61 0 0 1 0-.894.685.685 0 0 1 .936 0l3.531 3.369a.61.61 0 0 1 0 .893l-3.53 3.368ZM9.552 4.572h2.162v1.263H9.552zm-1.06 0v1.263h.004V4.572h1.058Zm-1.567 2.8a.685.685 0 0 1 .936 0 .61.61 0 0 1 0 .894l-2.4 2.29h1.005v1.263H5.46l2.401 2.29a.61.61 0 0 1 0 .893.685.685 0 0 1-.936 0l-3.531-3.368a.61.61 0 0 1 0-.893zm1.662 4.447H7.525v-1.263h1.062zm2.117 0H9.646v-1.263h1.058zm1.06 0h1.06v-1.263h-1.06zm2.119 0h1.455c.366 0 .662-.283.662-.632 0-.348-.296-.631-.662-.631h-1.455z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m2.47 5.11 1.705-1.704m1.704-1.704L4.175 3.406m0 0L2.47 1.702m1.705 1.704 1.704 1.705"
    />
  </svg>
);
export const DisconnectedArrowsArrowsIcon = forwardRef(
  SvgDisconnectedArrowsArrows,
);
